import { z } from 'zod';

const PeriodInfoSchema = z.object({
  dateRange: z.string(),
  isConfirmed: z.boolean(),
});

const OrderAmountInfoSchema = z.object({
  total: z.string(),
  direct: z.string(),
  indirect: z.string(),
  exclusive: z.string(), // 단독 상품 주문 금액
});

const TotalStatsInfoSchema = z.object({
  orderCount: z.number().int(),
  orderAmount: z.string(),
  earnings: z.string(),
  visitCount: z.number().describe('방문 건수'),
});

const OrderCountInfoSchema = z.object({
  total: z.number().int(),
  direct: z.number().int(),
  indirect: z.number().int(),
  exclusive: z.number().int(), // 단독 상품 주문 건수
});

const EarningsInfoSchema = z.object({
  total: z.string(),
});

const DetailPerformanceSchema = z.object({
  earnings: EarningsInfoSchema,
  orderAmount: OrderAmountInfoSchema,
  orderCount: OrderCountInfoSchema,
  visitCount: z.number().int(),
});

const ServiceBoostingPerformanceSchema = z.object({
  promotionName: z.string(),
  promotionPeriod: z.string(),
  additionalCommissionRate: z.string(),
  expectedBoostingEarnings: z.string(),
});

export const GetMonthlyRevenueServiceResponseSchema = z.object({
  period: PeriodInfoSchema,
  totalStats: TotalStatsInfoSchema,
  goods: DetailPerformanceSchema,
  curatorShop: DetailPerformanceSchema,
  boostingPerformance: ServiceBoostingPerformanceSchema.nullable().optional(),
});

export type GetMonthlyRevenueServiceResponse = z.infer<
  typeof GetMonthlyRevenueServiceResponseSchema
>;

export type ServiceMonthInfo = z.infer<typeof PeriodInfoSchema>;
export type ServiceDetailPerformance = z.infer<typeof DetailPerformanceSchema>;
export type ServiceBoostingPerformance = z.infer<typeof ServiceBoostingPerformanceSchema>;
